export const SELECTED_SUBSCRIPTION_ID_LOCAL_KEY = 'USER_SELECTED_SUBSCRIPTION';